import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartemasterhistoriqueComponent } from './cartemasterhistorique.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { ShowComponent } from './show/show.component';
import { MotifComponent } from './motif/motif.component';

@NgModule({
  declarations: [CartemasterhistoriqueComponent, ShowComponent, MotifComponent],
  entryComponents: [ShowComponent , MotifComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    FurySharedModule,
  ]
})
export class CartemasterhistoriqueModule { }
